import { render, staticRenderFns } from "./WebprofitDetail.vue?vue&type=template&id=0daaae3e&scoped=true&"
import script from "./WebprofitDetail.vue?vue&type=script&lang=js&"
export * from "./WebprofitDetail.vue?vue&type=script&lang=js&"
import style0 from "./WebprofitDetail.vue?vue&type=style&index=0&id=0daaae3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daaae3e",
  null
  
)

export default component.exports